import React from 'react';
import classNames from 'classnames';
import { List } from 'immutable';

import { Paragraph, Taxonomy } from '@uncinc/react-drupal-core';
import { Container, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import { Breadcrumbs } from '../../../components';

import './style.scss';

const NodeSuccessPage = ({ entity, className }) => {
  const classes = classNames(className, 'NodeSuccessPage');

  const title = entity.getIn(['title', 0, 'value'], '');
  const body = entity.getIn(['body', 0, 'processed'], '');
  const organizationEntity = entity.getIn(['field_municipality', 0, 'entity', 'field_organization', 0, 'entity'], '');

  return (
    <article className={classes} itemScope itemType="https://schema.org/WebPage">
      <Container>
        <Breadcrumbs />
        <div className="NodeSuccessPage__wrapper u-indent--large">
          <h1>{title}</h1>
          {body && (
            <p className="text-large">
              <WysiwygField
                property="schema:text"
                html={body}
              />
            </p>
          )}
          {entity.get('field_paragraphs') ? (
            <div className="NodeSuccessPage__paragraphs">
              {entity.get('field_paragraphs', List()).map((paragraph) => {
                const id = paragraph.get('target_id');
                const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);
                return (
                  <Paragraph
                    key={`paragraph:${id}:${language}`}
                    id={id}
                    entity={paragraph.get('entity')}
                  />
                );
              })}
            </div>
          ) : null}
          <div className="NodeSuccessPage__organization">
            <Taxonomy entity={organizationEntity} viewMode="small" />
          </div>
        </div>
      </Container>
    </article>
  );
};

export default NodeSuccessPage;
